import { useMutation } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";
import axios from "axios";
import { DPO } from "../types/DPO";

export const useCreateDPODetail = () => {
  const { authHeader } = useAuth();

  return useMutation((params: DPO) => {
    return axios.post(`${env.verifyServiceUrl}user/dpo/`, params, {
      headers: {
        Authorization: authHeader,
      },
    });
  });
};
